// extracted by mini-css-extract-plugin
export default {"root":"FormTitle_root__bpbbu","title":"FormTitle_title__By1uD"};